import { styled, useMediaQuery } from '@mui/material';

export const DpCenterContainer = styled('div')<{
	isPlP?: boolean;
}>(({ theme, isPlP }) => ({
	maxWidth: `${isPlP ? theme.breakpoints.values.lg * 2 : theme.breakpoints.values.lg}px`,
	width: useMediaQuery(theme.breakpoints.down('lg'))
		? 'calc(100vw - 40px)'
		: isPlP
		? '95vw'
		: '90vw',
	padding: '0',
}));
